const abTestState = {
  data: {
    title: '',
    startDate: '',
    endDate: '',
    baseCampaignId: '',
  },
};

export default abTestState;
